export const PAGE_SIZE = 24;

const SEXES = ["male", "female", "unknown", "pair"];

// The API docs describe unpriced slots as null, but real data uses 0.
// Both mean "no price"; returning null lets callers show "price on request".
export const formatPrice = (value, currency) => {
  if (!value) {
    return null;
  }
  return currency ? `${currency} ${value}` : `${value}`;
};

// Quantities can be the string "x", meaning the CRM has no specified count.
// Never coerce or do arithmetic on these.
export const formatQuantity = (value) => `${value}`;

export const coverImage = (images) => {
  if (!images || images.length === 0) {
    return null;
  }
  return images.find((image) => image.is_cover) || images[0];
};

// Prices are restricted to members outside the EU. When they are hidden the
// whole `prices` key is absent — not nulled, not zeroed. The flag depends on
// the logged-in member, not the item, so it is identical across a response.
// Requiring `prices` too means a flag that disagrees with the payload can't
// crash a caller that trusted it, and records predating the flag still work.
export const arePricesVisible = (record) =>
  record.prices_visible !== false && Boolean(record.prices);

export const priceCurrency = (record) =>
  record.prices ? record.prices.currency : null;

const hasStock = (quantity) =>
  typeof quantity === "number" ? quantity > 0 : Boolean(quantity);

export const stockRows = (record) =>
  SEXES.filter((sex) => hasStock(record.quantities[sex])).map((sex) => ({
    sex,
    quantity: record.quantities[sex],
    price: record.prices ? record.prices[sex] : null,
  }));

export const titleCase = (name) =>
  (name || "").toLowerCase().replace(/\b[a-z]/g, (c) => c.toUpperCase());

export const pageCount = (total) => Math.ceil((total || 0) / PAGE_SIZE);

// Records carry no server-side Spanish fallback, unlike the facets endpoint.
export const displayName = (record, activeLang) =>
  (activeLang === "es" && record.spanish_name) || record.common_name;
